import React, { useEffect, useState } from "react";
import { browserName, browserVersion } from "react-device-detect";

import copy from 'clipboard-copy';
// import deleteImg from "../components/images/delete.svg";
import deleteImg from "../../components/images/delete.svg";
import {
    MDBAlert,
    MDBCard,
    MDBCardBody,
    MDBCardText,
    MDBIcon,
    MDBRadio
} from 'mdb-react-ui-kit';

import {
    getGBussinessInfo,
} from "../../services/classApiServices.js";
import {
    isEmail,
    isEmpty,
    isValidPhoneNumber
} from "../../validators/helper.js";
import PageError from "../../views/PageError";
import { createRazorpayGateway, getRazorpayGateway } from "../../services/classApiServices";

function PaymentGateway({ callbackfunction }) {
    const [ddgst, setDdgst] = useState(true);
    const [error, setError] = useState({});
    const [dpaymethods, setDpaymethods] = useState([]);
    const [userpaymethods, setUserpaymethods] = useState([]);
    const [selectedUOpts, setselecteUOpts] = useState([]);
    const [dgsttax, setDgsttax] = useState([]);
    const [ugsttax, setUgsttax] = useState([]);
    const [gstopt, setGstopt] = useState([]);
    const [emailrem, setEmailrem] = useState([]);
    const [smsrem, setSmsrem] = useState([]);
    const [can, setCan] = useState(false)
    const [businessForm, setbusinessForm] = useState({
        businessName: "",
        businessEmail: "",
        firstName: "",
        lastName: "",
        contactNumber: "",
        memberCapacity: "",
        state: "",
        city: "",
        address: "",
        prefix: "",
        dpaymethods: dpaymethods,
        userpaymethods: userpaymethods,
        dgsttax: dgsttax,
        ugsttax: ugsttax,
        shortcode: "",
        emailrem: emailrem,
        smsrem: smsrem,
        emailinter: "h",
        smsinter: "h",
        timezone: null,
    });
    const [form, setForm] = useState({
        merchantid: "",
        merchantkey: "",
        status: false,
        isenable: false,
        gymid: -1,
        _id: -1,
        merchantisenable: false,
    });
    const [emptyErrorPaymentLink, setEmptyErrorPaymentLink] = useState(false);
    const [Error2, setError2] = useState("")
    const [apiError, setApiError] = useState(false);
    function updateForm(value) {
        return setForm((prev) => {
            return { ...prev, ...value };
        });
    }

    useEffect(() => {
        async function fetchData() {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getGBussinessInfo(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );

                if (!response) {

                    return;
                }
                if (response === "false") {
                    setApiError(true);
                    return;
                } else {
                    const record = await response.json();
                    if (!record) {
                        return;
                    }
                    setbusinessForm(record);
                    setEmailrem(record.emailrem);
                    setSmsrem(record.smsrem);
                    setDpaymethods(record.dpaymethods);
                    setDgsttax(record.dgsttax);
                    if (record.ddgst === false) {
                        setDdgst(false);
                    }
                    let temOpts = [];
                    record.userpaymethods.forEach((opt) => {
                        if (opt.check) {
                            temOpts.push(opt._id);
                        }
                    });
                    setselecteUOpts(temOpts);
                    setUserpaymethods(record.userpaymethods);
                    let gsttaxoption = [];
                    record.ugsttax.forEach((opt) => {
                        if (opt.check) {
                            gsttaxoption.push(opt._id);
                        }
                    });
                    setGstopt(gsttaxoption);
                    setUgsttax(record.ugsttax);
                }
                await fetchPaymentLink();
            }
        }
        fetchData();
    }, []);
    async function fetchPaymentLink() {
        const paymentLinkSetting = await getRazorpayGateway(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
        if (!paymentLinkSetting) {
            return;
        }
        const paymentLinkSettings = await paymentLinkSetting.json();
        // if (paymentLinkSettings.gymid) {
        console.log(paymentLinkSettings);
        setForm(paymentLinkSettings);
        // }
    }


    let validateForm = (e) => {
        console.log("Validating form...");
        let errors = {};
        if (isEmpty(businessForm.businessName)) {
            errors.businessname = "Business Name can't be blank";
        }
        if (isEmpty(businessForm.businessEmail)) {
            errors.businessEmail = "Email can't be blank";
        } else if (!isEmail(businessForm.businessEmail)) {
            errors.businessEmail = "Please enter valid email";
        }
        if (isEmpty(businessForm.firstName)) {
            errors.firstname = "First Name can't be blank";
        }
        if (isEmpty(businessForm.lastName)) {
            errors.lastName = "Last Name can't be blank";
        }
        if (isEmpty(businessForm.contactNumber)) {
            errors.contactNumber = "Contact Number can't be blank";
        } else if (!isValidPhoneNumber(businessForm.contactNumber)) {
            errors.contactNumber = "Please enter valid Contact Number";
        }
        // if (isEmpty(businessForm.memberCapacity)) {
        //   errors.memberCapacity = "Member Capacity can't be blank";
        // }

        if (isEmpty(businessForm.city)) {
            errors.city = "City can't be blank";
        }
        if (isEmpty(businessForm.address)) {
            errors.address = "Address can't be blank";
        }
        userpaymethods.forEach((item, index) => {
            if (!item.title) {
                errors[`title_${index}`] = `Title  can't be blank`;
            }
            else if (!isAlphabetical(item.title)) {
                errors[`title_${index}`] = `Title  should contain only alphabetical characters`;
            }
        });
        // if (isEmpty(businessForm.prefix)) {
        //   errors.prefix = "Transaction id prefix can't be blank";
        // }

        if (isEmpty(errors)) {
            return true;
        } else {
            return errors;
        }
    };
    function addNewRow(e) {
        e.preventDefault();
        if (userpaymethods.length >= 10) {
            window.alert("Maximum limit reached");
            return;
        }
        setUserpaymethods([...userpaymethods, { check: "", title: "", label: "" }]);
    }
    function deleteRow(e, index) {
        e.preventDefault();
        setUserpaymethods((current) =>
            current.filter((obj, tindex) => tindex !== index)
        );
        setError((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[`title_${index}`];
            return newErrors;
        });
    }

    const isAlphabetical = (str) => /^[a-zA-Z]+$/.test(str);
    function processCancel() {
        setCan(!can)
        window.location.href = "/bInfo";
    }
    function addMethod(e, tid, isdded) {
        try {
            console.log(isdded);
            let ischecked = isdded ? false : true;
            console.log("ischecked :: " + ischecked);
            if (ischecked) {
                setDpaymethods([...dpaymethods, tid]);
            } else {
                const nmethods = dpaymethods.filter((item) => item !== tid);
                setDpaymethods(nmethods);
            }
        } catch (e) {
            console.log("Error ::::::::::;; " + e);
        }
    }

    function addUMethod(e, tid, isdded) {
        try {
            //e.preventDefault();
            console.log(isdded);
            let ischecked = isdded ? false : true;
            console.log("ischecked :: " + ischecked);
            if (ischecked) {
                setselecteUOpts([...selectedUOpts, tid]);
            } else {
                const nmethods = selectedUOpts.filter((item) => item !== tid);
                setselecteUOpts(nmethods);
            }
            //updateForm({ dpaymethods: dpaymethods });
        } catch (e) {
            console.log("Error ::::::::::;; " + e);
        }
    }

    function updateTitle(obj) {
        setUserpaymethods((prevState) => {
            const newState = prevState.map((eachObj, index) => {
                if (index === obj.index) {
                    return {
                        _id: eachObj._id,
                        check: eachObj.check,
                        title: obj.title,
                        label: eachObj.label,
                    };
                }
                // 👇️ otherwise return object as is
                return eachObj;
            });
            return newState;
        });
    }
    async function submitPaymentLinkData(transactionId) {
        try {
            let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
            const updates = {
                gymid: gymid,
                merchantid: form.merchantid,
                merchantkey: form.merchantkey,
                status: 2,
                isenable: form.isenable,
            };
            if (transactionId != null) {
                updates.transactionId = transactionId;
            }
            callbackfunction(false);

            return;
        } catch (e) {
            console.log(e)
            return;
        }
    }

    function generateUniqueKey(length) {
        const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let uniqueKey = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            uniqueKey += characters.charAt(randomIndex);
        }
        return uniqueKey;
    }
    async function confirmPaymentLinkHandler(e) {
        e.preventDefault();
        if (form.merchantid === "" || form.merchantkey === "") {
            setEmptyErrorPaymentLink(true);
            return;
        }
        try {
            let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
            const updates = {
                gymid: gymid,
                merchantid: form.merchantid,
                merchantkey: form.merchantkey,
                status: form.status,
                isenable: form.isenable,
                _id: form._id,
                merchantisenable: form.merchantisenable,
            };
            let saverep = await createRazorpayGateway(gymid, updates);
            const recinfo = await saverep.json();
            console.log(recinfo);

        } catch (e) {
            console.log(e)
            return;
        }
    }

    async function onSubmit(e) {



    }

    const handleReload = () => {
        window.location.reload();
    }

    console.log(form, 'formformformformform');

    return (
        <React.Fragment>
            <>

                {apiError ? <PageError handleReload={handleReload} /> :
                    <form
                        action="#"
                        target="_blank"
                    // onSubmit={onSubmit}
                    >


                        <div className="gym-main rightContent pb-4 pt-0">
                            <div className="BusinessPage__content">

                                <MDBCard className='shadow-0'>
                                    <MDBCardBody className='py-0 px-0'>

                                        <MDBCardText>
                                            <div className="payments">

                                                <div className="phoneselect d-flex align-items-center justify-content-between">
                                                    <label>Razorpay Payment</label>
                                                    <label className="m-0 ms-2 switch"
                                                    >
                                                        <input className="form-control" type="checkbox" checked={form.isenable} onChange={(e) => updateForm({ isenable: !form.isenable })}
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                </div>


                                                <div className="phoneselect mt-3 d-flex align-items-center">
                                                    <MDBRadio name='flexRadioDefault' id='flexRadioDefault1' label='Use Easymember Razorpay Gateway' checked={!form.merchantisenable}
                                                        onChange={(e) => updateForm({ merchantisenable: !form.merchantisenable })}
                                                    />
                                                </div>

                                                <div>

                                                    <div className="phoneselect mt-1 d-flex align-items-center">
                                                        <MDBRadio name='flexRadioDefault' id='flexRadioDefault2' label="Add Razorpay Gateway" checked={form.merchantisenable}
                                                            onChange={(e) => updateForm({ merchantisenable: !form.merchantisenable })}
                                                        />
                                                    </div>


                                                    {form.merchantisenable && <>
                                                        <div>
                                                            <div className=" Business__Details__data">
                                                                <label>Merchant ID:<span className="text-danger">*</span></label>
                                                                <label className="fw-600">
                                                                    <label className="fw-600">
                                                                        <input className="Business__input__adjust" type="text" name="bussiness_name" id="bussiness_name" placeholder="Merchant Id"
                                                                            onChange={(e) => updateForm({ merchantid: e.target.value })}
                                                                            value={form.merchantid} />

                                                                    </label>

                                                                </label>
                                                            </div>
                                                            <div className=" Business__Details__data mt-2">
                                                                <label>Merchant Key:<span className="text-danger">*</span></label>
                                                                <label className="fw-600">
                                                                    <label className="fw-600">
                                                                        <input className="Business__input__adjust" type="text" name="bussiness_name" id="bussiness_name" placeholder="Merchant Key"
                                                                            onChange={(e) => updateForm({ merchantkey: e.target.value })}
                                                                            value={form.merchantkey} />

                                                                    </label>

                                                                </label>
                                                            </div>

                                                            {form.status &&
                                                                <label className="clr-green">
                                                                    <MDBIcon fas icon="check" /> Confirmed
                                                                </label>}

                                                            {/* <button className="btn btn-primary me-0 mt-3 mb-2" onClick={(e) => { confirmPaymentLinkHandler(e) }} >
                                                                        Pay yourself
                                                                    </button> */}
                                                        </div>
                                                        {!form.status && <>
                                                            Note: Send Rs.100/- to your account for confirmation.
                                                        </>}
                                                    </>}




                                                </div>
                                            </div>
                                        </MDBCardText>
                                    </MDBCardBody>
                                </MDBCard>
                            </div>
                        </div>


                        <div className="modal-footer pb-0">
                            <button className="ripple ripple-surface btn btn-secondary" onClick={() => processCancel()} >
                                Cancel
                            </button>
                            <button className="ripple ripple-surface btn btn-primary" type="submit" onClick={(e) => { confirmPaymentLinkHandler(e) }} >
                                {form.status ? "Save" : "Conform & Save"}
                            </button>

                        </div>
                    </form>}
                <MDBAlert
                    color={Error2.includes("ailed") ? "danger" : "success"}
                    autohide
                    position='top-right'
                    delay={3000}
                    appendToBody
                    open={Error2 !== ""}
                    onClose={() => setError2("")}
                >
                    {Error2}
                </MDBAlert>
            </>
        </React.Fragment>
    )
}

export default PaymentGateway